import { useStyles } from "@webapps/styles";
import { Checkbox } from "@material-ui/core";

function ActivityPlanning({ activities, onToggle, visibleMap = {} }) {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  return (
    <div className={classes.categoryContainer}>
      <div className={cx(classes.categoryContainerTitle, global.title)}>
        Activités
      </div>
      <div className={classes.mapContainer}>
        {activities.map((activity) => (
          <div
            key={activity.key || activity.label}
            className={classes.category}
            onClick={() => onToggle && onToggle(activity.key || activity.label)}
          >
            <div className={classes.duoInputTitle}>
              <Checkbox
                className={css({
                  padding: '0px',
                  '.MuiIconButton-label': { color: activity.color },
                })}
                checked={visibleMap[activity.key || activity.label] ?? true}
                name={activity.key || activity.label}
                disableTouchRipple={true}
                disableRipple={true}
                readOnly={!onToggle}
              />
              <div className={cx(classes.categoryTitle, global.titleMediaQuery)}>
                {activity.label}
              </div>
            </div>
            <div className={cx(classes.categoryTotal, global.subTitleMediaQuery)}>
              {`${activity.day}j - ${activity.hour}h`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = () => ({
  categoryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '20px',
    borderRadius: '22px',
    backgroundColor: "white",
    fontFamily: "Montserrat",
  },
  categoryContainerTitle: {},
  mapContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  category: {
    fontFamily: "Montserrat",
    padding: '10px',
    borderRadius: '10px',
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    padding: "0px",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
  },
  duoInputTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  categoryTitle: {
    fontWeight: "500",
    color: "#152652",
  },
  categoryTotal: {
    fontWeight: "400",
    color: "#152652",
    fontStyle: "italic"
  },
});

export default ActivityPlanning; 